import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse,HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';

@Injectable()
export class AuthenticationService {
    constructor(private http: HttpClient) { }

    login(username: string, password: string) {
        let urlApi = 'https://carbooking.snru.ac.th/back_end/Login_API.php';
        let data = { username: username, password: password };
        return this.http.post<any>(urlApi,data)
        .map(user =>{ 
            let use = Observable.of(user);
            console.log(use)
            if (user && user[0]['token']) {
               
                localStorage.setItem('currentUser', JSON.stringify(user));
                return Observable.of(user);
                // store user details and jwt token in local storage to keep user logged in between page refreshes
            }
            else {
                // else return 400 bad request
                return Observable.throw('ชื่อเข้าใช้ หรือ รหัสผ่านไม่ถูกต้อง');
            }
        });
      

        /*return this.http.post<any>('/api/authenticate', { username: username, password: password })
            .map(user => {
                console.log(user);
                // login successful if there's a jwt token in the response
                if (user && user.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                }

                return user;
            });*/
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
    }
}


// WEBPACK FOOTER //
// D:/Programing/carbooking/src/app/shared/services/authentication.service.ts